import {
  ContactUs,
  News,
  FAQ,
  ClubLoyaltyInfo,
  VisionMissionDonate,
  SubsClubSubscribe,
  SubscribeProcess,
  SubscribeFailure,
  CinemasPage
} from '@/components/pages'
import {NewsDetail} from '@/components/news'
import {Donate, ConfirmDetails, MakeDonation, DonationSuccessful, DonationUnsuccessful} from '@/components/donate'
import {SubsConfirmDetails, SubscriptionSummary, SubsMakePayment, SubsProgressSteps} from '@/components/subs-club'

export default [
  // Footer area 1
  {
    path: '/contact-us',
    name: 'Contact Us',
    footer: '1',
    component: ContactUs
  },
  {
    path: '/contact-us/:type',
    name: 'Contact Us Type',
    component: ContactUs
  },
  {
    path: '/find-cinemas/:cinema',
    name: 'Find a Cinema Selected',
    component: CinemasPage,
  },
  {
    path: '/find-cinemas',
    name: 'Find a Cinema',
    footer: '1',
    component: CinemasPage,
  },
  {
    path: '/faq',
    name: 'FAQ',
    footer: '1',
    redirect:'/content/faq',
    redirectParams: {
      responseCode: 301
    },
    component: FAQ
  },
  // Footer area 2
  {
    // path: '/sales-at-sk',
    url:'/content/sales-at-sk',
    name: 'Sales at SK',
    footer: '2',
    children: [
      {
        url:'/content/sales-at-sk/advertising',
        name: 'Advertising',
      },
      {
        url:'/content/sales-at-sk/conferencing-and-venue-hire',
        name: 'Conferencing and Venue Hire',
      },
      {
        url:'/content/sales-at-sk/private-screening',
        name: 'Private Screenings',
      },
      {
        url:'/content/sales-at-sk/promotions-and-incentive',
        name: 'Promotions and Incentives',
      },
      {
        url:'/content/sales-at-sk/cannes-lions',
        name: 'Cannes Lions',
      }
    ]
  },
  {
    url: '/content/about-ster-kinekor',
    name: 'About',
    footer: '3',
  },
  {
    url: '/content/careers',
    name: 'Careers',
    footer: '3',
  },
  {
    url: '/content/procurement',
    name: 'Procurement',
    footer: '3',
  },
  {
    url: '/content/vision-mission',
    name: 'Vision Mission',
    footer: '3',
  },
  {
    path: '/news/:filter',
    name: 'NewsFiltered',
    component: News,
  },
  {
    path: '/news',
    name: 'News Footer',
    footer: '3',
    component: News,
  },
  {
    path: '/news/detail/:nid',
    name: 'NewsDetailOld',
    component: NewsDetail,
  },
  {
    path: '/news/detail/:nid/:slug',
    name: 'NewsDetail',
    component: NewsDetail,
  },
  {
    path: '/news/blogs/detail/:nid/:slug',
    name: 'NewsBlogDetail',
    component: NewsDetail,
  },
  {
    path: '/news/genres/detail/:nid/:slug',
    name: 'NewsGenresDetail',
    component: NewsDetail,
  },
  // Footer area 4
  {
    path: '/sk-club',
    name: 'SK Club',
    footer: '4',
    redirect: '/club-loyalty/SK_Club',
    component: ClubLoyaltyInfo
  },
  {
    path: '/subs-club',
    name: 'SK Subs Club',
    footer: '4',
    redirect: '/subscription-club',
    component: ClubLoyaltyInfo
  },
  {
    path: '/discovery-vitality',
    name: 'Discovery Vitality',
    footer: '4',
    redirect: '/club-loyalty/Discovery_Vitality',
    component: ClubLoyaltyInfo
  },
  {
    path: '/edgars-club',
    name: 'Edgars Club Movie Benefit',
    footer: '4',
    redirect: '/club-loyalty/Edgars_Club',
    component: ClubLoyaltyInfo
  },
  {
      path: '/donate',
      name: 'Donate',
      footer: '5',
      redirect: '/donate/1',
      component: VisionMissionDonate,

      children: [
          {
              path: '1',
              name: 'DonateStep',
              footer: '5',
              component: Donate
          },
          {
              path: '2',
              name: 'ConfirmDetails',
              component: ConfirmDetails
          },
          {
              path: '3',
              name: 'MakeDonation',
              component: MakeDonation
          }
      ]
  },
  {
      path: '/donation-successful/:booking_number/:booking_id',
      name: 'donationSuccess',
      component: DonationSuccessful
  },
  {
      path: '/donation-unsuccessful',
      name: 'donationFailure',
      component: DonationUnsuccessful
  },
  // Footer area 6
  {
      url: '/content/legal',
      name: 'Legal',
      footer: '6',
      // component: Legal,
      children: [
        {
            url: '/content/legal/online-booking-terms-and-conditions',
          name: `Online Booking T's & C's`,
          footer: '6',
          // component: Legal
        },
        {
            url: '/content/legal/club-terms-and-conditions',
          name: `SK Club T's & C's`,
          footer: '6',
          // component: Legal
        },
        {
            url: `/content/legal/SK%20SUBSCRIPTION%20CLUB%20T'S%20&%20C'S`,
          name: `SK Subscription Club T's & C's`,
          footer: '6',
          // component: Legal
        },
        {
            url: '/content/legal/privacy-policy',
          name: 'Privacy Policy',
          footer: '6',
          // component: Legal
        },
        {
          url: '/content/legal/cookie-policy',
          name: 'Cookie Policy',
          footer: '6',
          // component: CinemaExperience
        },
        {
          url: '/static/popi-act-disclaimer.pdf?v=1',
          name: 'POPI Act',
          footer: '6',
          target: "blank",
          // component: CinemaExperience
        },
        {
          url: '/static/paia-manual.pdf?v=1',
          name: 'PAIA Manual',
          footer: '6',
          target: "blank",
          // component: CinemaExperience
        },
        {
          url: '/middleware/sitemap/movies',
          name: 'Sitemap',
          target: "blank",
          footer: '6',
        },
      ]
    },

    {
      path: '/subscribe',
      name: 'Subscribe',
      redirect: '/subscribe/1',
      component: SubsClubSubscribe,

      children: [
          {
              path: '1',
              name: 'SubscriptionSummary',
              component: SubscriptionSummary
          },
          {
              path: '2',
              name: 'SubsConfirmDetails',
              component: SubsConfirmDetails
          },
          {
              path: '3',
              name: 'SubsMakePayment',
              component: SubsMakePayment
          }
      ]
    },

    {
      path: '/subscribe-success/:psRef/:transactionId',
      name: 'SubscribeProcess',
      component: SubscribeProcess
    },

    {
      path: '/subscribe-failure',
      name: 'SubscribeFailure',
      component: SubscribeFailure
    },
]



// WEBPACK FOOTER //
// ./src/router/footer-nav.js